import React, { Component,  } from 'react';
import styled from 'styled-components';

import { isiOS } from 'config';
import {
  androidNavbarTopRowHeight,
} from 'themes';
import  { Page } from '../../components/v2/Common';

interface ScrollContainerProps {
  navbarHeight: number;
  scrollKey: string;
}
export class ScrollContainer extends Component<ScrollContainerProps> {
  state = {
    scrolling: false,
    top: 0
  };

  onScroll = ({ scrolling = false, top = 0 }) => {
    if (isiOS && this.state.scrolling === scrolling) {
      return;
    }
    if (top > androidNavbarTopRowHeight) {
      top = androidNavbarTopRowHeight;
    }
    if (this.state.scrolling === scrolling && this.state.top === top) {
      return;
    }
    this.setState({
      scrolling,
      top
    });
  };

  render() {
    const { children, navbarHeight, scrollKey } = this.props;
    return (
        <Page
            onScroll={this.onScroll}
            navbarHeight={navbarHeight}
            scrollKey={scrollKey}
        >
          {children}
        </Page>
    );
  }
};
